import PropTypes from "prop-types"
import React from "react"
import { usePageAssets } from "hooks/usePageAssets"
import Heading from "components/ui/Heading"
import SkewedSection from "components/ui/Layout/SkewedSection"
import SplitContainer from "components/ui/Layout/SplitContainer"

function NoCodeVisualizationsSection({ className }) {
  const { getAsset } = usePageAssets()
  const illustration = getAsset("internal-bi-no-code-visualizations")
  return (
    <SkewedSection className={className}>
      <SplitContainer
        className="py-10 lg:py-20 xl:py-32 2xl:py-40"
        image={illustration}
        imageClassName="mt-8 md:mt-0 max-w-2xl mx-auto"
        reversed
      >
        <Heading
          label="No-Code Visualizations"
          title="Zero to dashboards in minutes"
          subtitle={
            <>
              Quickly build and share dynamic dashboards that showcase your data
              with just a few clicks. Choose from over 40+ pre-installed
              visualizations, or create your own to suit your business needs.
            </>
          }
          narrow
        />
      </SplitContainer>
    </SkewedSection>
  )
}

NoCodeVisualizationsSection.propTypes = {
  /** Additional className(s) */
  className: PropTypes.string,
}

export default NoCodeVisualizationsSection
